// Thin API client. The bearer token (issued by POST /leads) is kept in
// sessionStorage and attached to every call once present.
import { apiBase } from './config/runtime.js';
import { entryFromPath } from './engine/entry.js';

const TOKEN_KEY = 'ntai_token';

// Tag every write with the landing door (/live -> 'live') so the server can stamp the
// HubSpot record. Sent on writes, not just the first /leads call, because a returning
// client can arrive with a session already open or sign in with a password instead.
const ENTRY = entryFromPath();

// sessionStorage can throw inside a third-party iframe (the PompaBooking embed) when the
// browser blocks third-party storage; the session then lives in memory for the page's
// life. Where storage works, behaviour is exactly as before.
let memoryToken = null;
export const getToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return memoryToken;
  }
};
export const setToken = (t) => {
  memoryToken = t || null;
  try {
    if (t) sessionStorage.setItem(TOKEN_KEY, t);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch { /* storage blocked: memoryToken holds it */ }
};

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const payload = ENTRY && body && typeof body === 'object' ? { ...body, entry: ENTRY } : body;
  const res = await fetch(`${apiBase()}${path}`, {
    method,
    headers,
    body: payload === undefined ? undefined : JSON.stringify(payload),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status, data });
  return data;
}

export const api = {
  health: () => request('GET', '/health'),
  get: (p) => request('GET', p),
  post: (p, b) => request('POST', p, b),
  patch: (p, b) => request('PATCH', p, b),
};
